// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"234":"b0925f0c","499":"80fd8135","618":"a5137f83","966":"eb7210a9"}[chunkId] + ".js";
};